var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(this.title),expression:"this.title"}]},[_c('keep-alive',[_c('router-view')],1),_c('ShowDetailTabbar',{attrs:{"slug":_vm.slug}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }